export default defineNuxtRouteMiddleware(async () => {
  const { getSession, user } = useAuthStore()
  const token = useCookie('token')

  // Se tiver token, carrega a sessão
  if (token.value && !user) {
    await getSession()
  }
})
